/* eslint-disable react/prop-types */
import React from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
  Avatar,
  Fade,
} from '@mui/material';

const ModernCard = ({
  title,
  subtitle,
  description,
  icon,
  image,
  buttonText,
  onButtonClick,
  color = '#94B754',
  delay = 0,
  elevation = 0,
}) => {
  return (
    <Fade in={true} timeout={600} style={{ transitionDelay: `${delay}ms` }}>
      <Card
        elevation={elevation}
        sx={{
          height: '100%',
          borderRadius: 3,
          border: '1px solid #E0E0E0',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          cursor: 'pointer',
          '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: '0 12px 24px rgba(0,0,0,0.15)',
            border: `1px solid ${color}`,
          },
        }}
      >
        {/* Image Section */}
        {image && (
          <Box sx={{ position: 'relative', overflow: 'hidden' }}>
            <Box
              component="img"
              src={image}
              alt={title}
              sx={{
                width: '100%',
                height: 200,
                objectFit: 'fill',
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
                transition: 'transform 0.3s ease',
              }}
            />
            {icon && (
              <Avatar
                sx={{
                  position: 'absolute',
                  top: 16,
                  right: 16,
                  backgroundColor: 'rgba(255,255,255,0.95)',
                  color: color,
                  width: 48,
                  height: 48,
                  backdropFilter: 'blur(10px)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                }}
              >
                {icon}
              </Avatar>
            )}
          </Box>
        )}

        {/* Content Section */}
        <CardContent
          sx={{ p: 3, flexGrow: 1, display: 'flex', flexDirection: 'column' }}
        >
          <Typography
            variant="h6"
            component="h3"
            sx={{
              fontWeight: 'bold',
              color: '#2C5530',
              mb: 1,
              lineHeight: 1.3,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {title}
          </Typography>

          {subtitle && (
            <Typography
              variant="body2"
              sx={{
                color: color,
                fontWeight: 600,
                mb: 1,
              }}
            >
              {subtitle}
            </Typography>
          )}

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              flexGrow: 1,
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              lineHeight: 1.5,
            }}
          >
            {description}
          </Typography>
        </CardContent>

        {/* Action Section */}
        {buttonText && onButtonClick && (
          <CardActions sx={{ p: 3, pt: 0 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={onButtonClick}
              sx={{
                backgroundColor: color,
                color: 'white',
                py: 1.5,
                borderRadius: 2,
                fontWeight: 600,
                textTransform: 'none',
                fontSize: '0.95rem',
                boxShadow: `0 4px 12px ${color}40`,
                '&:hover': {
                  backgroundColor: color,
                  filter: 'brightness(0.9)',
                  transform: 'translateY(-1px)',
                  boxShadow: `0 6px 16px ${color}50`,
                },
              }}
            >
              {buttonText}
            </Button>
          </CardActions>
        )}
      </Card>
    </Fade>
  );
};

export default ModernCard;
